import { isEmpty, isNil, mapValues, keys, get } from 'lodash-es';
import { fetchDataByAsset } from './fetchDataByAsset';
import { aiDashboardAssets, aiCohortsMap } from '../configs/constants';
import api from '../api';

const { getCancelToken } = api.buildRequestCancelation();

// Usage Trends
// Response transformers
const usageTrendsTransformResponse = (data) => {
  if (isEmpty(data)) return { data: {} };

  return {
    data: {
      time_series: data,
    },
  };
};

// Request
export const fetchUsageTrends = () =>
  fetchDataByAsset(
    aiDashboardAssets.usageTrends,
    {},
    { transformResponse: (data) => usageTrendsTransformResponse(data) }
  );

// Usage Transitions
// Response transformers
const usageTransitionsTransformResponse = (data) => {
  if (isEmpty(data)) return { data: {} };

  const chartData = get(data, ['table_data'], {});

  const cohortOrder = keys(aiCohortsMap);

  const formattedChartData =
    (!!chartData &&
      cohortOrder.reduce(
        (acc, cohort) => [
          ...acc,
          ...(chartData[cohort]
            ? cohortOrder.map((nextCohort) => [
                aiCohortsMap[cohort],
                `End-${aiCohortsMap[nextCohort]}`,
                get(chartData, [cohort, nextCohort], null),
              ])
            : []),
        ],
        []
      )) ||
    [];

  return {
    data: {
      table_data: chartData,
      chart_series: chartData ? formattedChartData : [],
    },
  };
};

// Request
export const fetchUsageTransitions =
  (nextFilters = {}) =>
  (dispatch, getState) => {
    const { aiDashboard } = getState();
    const { filters } = aiDashboard[aiDashboardAssets.usageTransitions];

    const requestFilters = {
      ...filters,
      ...nextFilters,
    };

    dispatch(
      fetchDataByAsset(aiDashboardAssets.usageTransitions, requestFilters, {
        cancelToken: getCancelToken('usageTransitions').token,
        transformResponse: (data) => usageTransitionsTransformResponse(data),
        decorateRequestAction: (action) => ({
          ...action,
          filters: requestFilters,
        }),
      })
    );
  };

// Segment Concentration
// Response transformers
const segmentConcentrationTransformResponse = (data) => {
  if (isEmpty(data)) return { data: {} };

  return {
    data: {
      time_series: mapValues(data.cohorts, (cohortData) =>
        mapValues(cohortData, (metricsData) =>
          (metricsData?.mau_v2_segment_share || []).map(([timestamp, value]) => [
            timestamp,
            isNil(value) ? null : value * 100,
          ])
        )
      ),
    },
  };
};

// Request
export const fetchSegmentConcentration = () =>
  fetchDataByAsset(
    aiDashboardAssets.segmentConcentration,
    {},
    { transformResponse: (data) => segmentConcentrationTransformResponse(data) }
  );
